import HomePage from '../components/home/HomePage';
import { getMainLayout } from '../components/layout/MainLayout';

HomePage.getLayout = getMainLayout({ bg: 'white' });

export default HomePage;
